(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const variantInput = this.form.querySelector('[name="id"]');
      if (
        (variantInput && !variantInput.value) ||
        this.submitButton.getAttribute('aria-disabled') === 'true'
      ) {
        this.flagMissingSelection();
        return;
      }

      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    flagMissingSelection() {
      const selector = document.querySelector('product-selector');
      if (!selector) return;
      const message = this.options.length > 1
        ? window.variantStrings?.selectOptions
        : window.variantStrings?.selectSize;
      this.handleErrorMessage(message || 'Select an option');
      selector.classList.remove('product-selector--needs-selection');
      // force reflow so the animation restarts
      void selector.offsetWidth;
      selector.classList.add('product-selector--needs-selection');
      const header = document.querySelector('header');
      const offset = (header?.clientHeight || 0) + 16;
      const top = selector.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    get options() {
      return Array.from(
        document.querySelectorAll('product-selector [data-input-wrapper]')
      );
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (!submitButton) return;
        if (disable) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.removeAttribute('disabled');
          if (text) submitButton.textContent = text;
        } else {
          submitButton.removeAttribute('aria-disabled');
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
